import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, MessageCircleIcon } from 'lucide-react';
export function HeroSection() {
  const whatsappLink = 'https://wa.me/17863975041?text=Hola%20Ricmary%2C%20quiero%20recibir%20el%20ebook%20GRATIS%20%22El%20Blindaje%20Familiar%20en%20USA%22.%20Vivo%20en%20%5BTU%20ESTADO%5D%20y%20quiero%20orientaci%C3%B3n%20para%20proteger%20a%20mi%20familia.';
  const bullets = ['Diferencias claras entre Term, Whole y Gastos Finales', 'Cómo pensar en cobertura según tu familia y responsabilidades', 'Errores típicos que hacen que la gente pague de más o elija mal', 'Preguntas clave para hablar con un agente con seguridad'];
  return <section className="bg-cream px-4 pt-8 pb-8 md:pt-10 md:pb-12 overflow-hidden" data-id="element-103">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row lg:items-center gap-6 lg:gap-8" data-id="element-104">
        {/* ── Left Column: Agent + Content + CTA (55%) ── */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} className="w-full lg:w-[50%] flex flex-col" data-id="element-105">
          {/* Agent strip */}
          <div className="flex items-center gap-3.5 mb-6" data-id="element-106">
            <img src="https://cdn.magicpatterns.com/uploads/1JwSqBnUNn8dkP6XiEPJMv/IMG_2060.png" alt="Ricmary Barcenas – Licensed Insurance Producer" className="w-16 h-16 md:w-[72px] md:h-[72px] rounded-full object-cover object-top border-[3px] border-white shadow-md flex-shrink-0" data-id="element-107" />
            <div className="min-w-0" data-id="element-108">
              <p className="font-bold text-navy text-sm md:text-base leading-tight" data-id="element-109">
                Ricmary Barcenas
              </p>
              <p className="text-xs md:text-sm text-gray-500 leading-snug" data-id="element-110">
                Licensed Insurance Producer – Life
              </p>
              <p className="text-[11px] text-gray-400 leading-snug mt-0.5" data-id="element-111">
                Licenciada en: CA, OH, NM, NJ, SC, FL, TX, AZ
              </p>
            </div>
          </div>

          {/* Company logo — subtle */}
          <div className="flex items-center gap-2 mb-5 opacity-60" data-id="element-112">
            <img src="https://cdn.magicpatterns.com/uploads/1eLdoLQgU8dwEpFk3PXX8K/IMG_4044.webp" alt="Senior Life Insurance Company" className="h-8 w-auto grayscale" data-id="element-113" />
            <span className="text-[10px] text-gray-400 uppercase tracking-wider font-medium" data-id="element-114">
              Respaldo
            </span>
          </div>

          {/* H1 */}
          <h1 className="font-heading text-[2rem] md:text-[2.75rem] lg:text-5xl text-navy font-bold leading-[1.15] mb-4" data-id="element-115">
            El Blindaje Familiar en USA{' '}
            <span className="text-gold" data-id="element-116">(Ebook GRATIS)</span>
          </h1>

          {/* H2 */}
          <h2 className="text-base md:text-lg text-gray-600 leading-relaxed mb-6 max-w-xl" data-id="element-117">
            Guía en español para entender el seguro de vida en Estados Unidos,
            evitar errores comunes y elegir una protección que tenga sentido
            para tu familia.
          </h2>

          {/* Bullets */}
          <ul className="space-y-3 mb-7" data-id="element-118">
            {bullets.map((bullet, i) => <li key={i} className="flex items-start gap-3" data-id="element-119">
                <span className="mt-1 flex-shrink-0 w-5 h-5 rounded-full bg-gold/20 flex items-center justify-center" data-id="element-120">
                  <CheckIcon className="w-3.5 h-3.5 text-gold-dark" data-id="element-121" />
                </span>
                <span className="text-gray-700 text-sm md:text-base font-medium leading-snug" data-id="element-122">
                  {bullet}
                </span>
              </li>)}
          </ul>

          {/* CTA */}
          <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="w-full max-w-[420px] mx-auto sm:mx-0 sm:w-auto inline-flex items-center justify-center gap-3 bg-whatsapp hover:bg-whatsapp-hover text-white px-8 py-3 rounded-xl font-bold text-base md:text-lg transition-all shadow-lg hover:shadow-xl hover:-translate-y-0.5" data-id="element-123">
            <MessageCircleIcon className="w-5 h-5 md:w-6 md:h-6" data-id="element-124" />
            Recibir por WhatsApp
          </a>

          {/* Microcopy */}
          <p className="mt-2 text-xs md:text-sm text-gray-400" data-id="element-125">
            Descarga 100% GRATIS. Antes se ofrecía a{' '}
            <span className="line-through" data-id="element-126">$17</span> — hoy es un bono sin
            costo.
          </p>
        </motion.div>

        {/* ── Right Column: iPad Mockup (45%) ── */}
        <motion.div initial={{
        opacity: 0,
        x: -120
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 1.1,
        delay: 0.2,
        ease: [0.22, 1, 0.36, 1]
      }} className="w-full lg:w-[50%] flex items-center justify-center lg:justify-end" data-id="element-127">
          <div className="w-full flex items-center justify-center lg:justify-end lg:-mr-4" data-id="element-128">
            <img src="https://cdn.magicpatterns.com/uploads/qdYLKrNxVP1jcmisUkmc6n/heylloyd-image-1774075840479.png" alt="El Blindaje Familiar en USA — Portada del ebook en tablet" className="w-full max-w-[440px] sm:max-w-[540px] lg:max-w-none lg:w-[105%] max-h-[52vh] lg:max-h-[88vh] object-contain drop-shadow-2xl" data-id="element-129" />
          </div>
        </motion.div>
      </div>
    </section>;
}